export const ITEMS_PER_PAGE = 20
export const ITEMS_PER_SECTION = 6
export const ITEMS_PER_SECTION_DOWN = 6
export const MOBILE_WIDTH = 768
